import React, { useEffect, useState } from "react";
import { Navigation } from "@shopify/polaris";
import { useNavigate, useLocation } from "react-router-dom";
import "@shopify/polaris/build/esm/styles.css";
import {
  HomeIcon,
  ProductIcon,
  CartIcon,
  CashDollarIcon,
  ProductFilledIcon,
  IdentityCardFilledIcon,
  ProfileIcon,
  SettingsIcon,
  QuestionCircleIcon
} from "@shopify/polaris-icons";
import Axios from "./Axios";

export function Sidenav() {
  const location = useLocation(); // Get the current route
  const navigate = useNavigate(); // Navigation hook
  const domain = process.env.REACT_APP_BASE_URL;
  const [SetupStep, setSetupStep] = useState("")
  const [loading, setLoading] = useState(false)


  useEffect(() => {
    const fetchData = async () => {
      try {
        const tempcode = localStorage.getItem("tempcode")
        if (tempcode) {
          setLoading(true)
          const url = `${process.env.REACT_APP_API_URL}/getuserdetail?key=${tempcode}`;
          const response = await Axios.get(url);

          if (response.status !== 200 || !response.data.success) {
            console.error("Failed to fetch user data:", response);
            return;
          }
          // console.log("Header ->>", response.data.success);
          // if(response.data.success.SetupStep == "Done" && response.data.success.TotalImportedproducts !== 0){
          if(response.data.success.SetupStep == "Done"){
            setSetupStep("Done");
          }
          
          setLoading(false)
        }

      } catch (error) {
        setLoading(false)

        console.error("Error fetching user data:", error);
      }
    };

    fetchData();
  }, []);


  const navigationMarkup = 
  (!loading ? 
    (SetupStep !== "Done" ?

    (<Navigation location={location.pathname}>
      <Navigation.Section
        items={[
          {
            url: `${domain}/`,
            label: "Dashboard",
            icon: HomeIcon,
            selected: location.pathname === `${domain}/`,
            onClick: () => navigate(`${domain}/`),
          }
        ]}

      />

    </Navigation>)
    :
    (
      <Navigation location={location.pathname}>
        <Navigation.Section
          items={[
            {
              //url: `${domain}/`,
              label: "Dashboard",
              icon: HomeIcon,
              selected: location.pathname === `${domain}/`,
              onClick: () => navigate(`${domain}/`),
            },
            {
              //url: `${domain}/products`,
              label: "Ebay Products",
              icon: ProductIcon,
              selected: location.pathname === `${domain}/products`,
              onClick: () => navigate(`${domain}/products`),
            },
            {
              //url: `${domain}/shopify_products`,
              label: "Shopify Products",
              icon: ProductFilledIcon,
              selected: location.pathname === `${domain}/shopify_products`,
              onClick: () => navigate(`${domain}/shopify_products`),
            },
            {
              //url: `${domain}/shopify_products`,
              label: "Ebay Account",
              icon: IdentityCardFilledIcon,
              selected: location.pathname === `${domain}/ebayaccounts`,
              onClick: () => navigate(`${domain}/ebayaccounts`),
            },
            // {
            //   //url: `${domain}ebayaccount`,
            //   label: "Ebay Account",
            //   icon: CartIcon,
            //   selected: location.pathname === `${domain}/ebayaccount`,
            //   onClick: () => navigate(`${domain}ebayaccount`),
            // },
            {
              url: `${domain}/profile`,
              label: "Profile",
              icon: ProfileIcon,
              selected: location.pathname.startsWith(`${domain}/profile`),
              subNavigationItems: [
                {
                  url: `${domain}/profile`,
                  label: "All Profiles",
                  selected: location.pathname === `${domain}/profile`,
                  onClick: () => navigate(`${domain}/profile`),
                },
                {
                  url: `${domain}/addprofile`,
                  label: "Add Profiles",
                  selected: location.pathname === `${domain}/addprofile`,
                  onClick: () => navigate(`${domain}/addprofile`),
                },
              ],
            },
            {
              //url: `${domain}/settings`,
              label: "Settings",
              icon: SettingsIcon,
              selected: location.pathname.startsWith(`${domain}/settings`),
              onClick: () => navigate(`${domain}/settings`),
              
            },

          ]}

        />
        <Navigation.Section
          items={[
            {
              //url: `${domain}/Plan&Pricing`,
              label: "Plan And Pricing",
              icon: CashDollarIcon,
              selected: location.pathname === `${domain}/Plan&Pricing`,
              onClick: () => navigate(`${domain}/Plan&Pricing`),
            },
            {
              //url: `${domain}/FAQ`,
              label: "FAQ",
              icon: QuestionCircleIcon,
              selected: location.pathname === `${domain}/FAQ`,
              onClick: () => navigate(`${domain}/FAQ`),
            },
          ]}
        />
      </Navigation>
    )
  )
    : <></>)
  

  return navigationMarkup;
}
